import React from "react";
import { useNavigate } from "react-router-dom";
import { useTracking } from "../../../../hooks/useTracking";
import Button from "../../../Button/Button";
// import "./Resultados.css";

const Resultados = ({
  pasaTest,
  imgOk,
  imgError,
  onReiniciar,
  testName = "",
  hospitalClient = "Vertex_Lab_Direct",
}) => {
  const navigate = useNavigate();
   const { trackEvent } = useTracking();
  const irASeccion = (seccion) => {
  navigate('/');
  setTimeout(() => {
    const el = document.getElementById(seccion);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, 100);
};

  const irAClinicas = () => {
    const params = new URLSearchParams();
    if (testName) params.set("test", testName);
    if (hospitalClient) params.set("hospital", hospitalClient);
    const qs = params.toString();
    navigate(qs ? `/clinicas?${qs}` : "/clinicas");
  };

    const handleAgendarCitaClick = () => {
    trackEvent("agendar_cita_click", {
      test_name: testName,
      hospital_client: hospitalClient,
      resultado: pasaTest ? "aprobado" : "requiere_revision",
      ubicacion: "resultados",
    });
    window.open("https://www.apec.org.mx/citas", "_blank", "noopener,noreferrer");
  };

  return (
    <div className={`test-container results`}>
      <h1 className="test-title">Tu Resultado</h1>

      {pasaTest ? (
        <div className="container-result">
          <p>
            Basado en tu prueba rápida, tu visión se encuentra dentro de los
            parámetros esperados. ¡Eso es fantástico!
          </p>
          <img src={imgOk} alt="imagen-ok" className="imgResult" />
          <div className="contenedor-result">
            {" "}
            <p className="texto-importante">
              Este test NO sustituye un examen optométrico u oftalmológico
              profesional.
            </p>
            <p>
              Te invitamos a nuestra sección de{" "}
              <button
                onClick={() => irASeccion("recommendations")}
                className="change-clinicas"
              >
                Recomendaciones Diarias{"  "}
              </button>
              para aprender pequeños hábitos que protegerán tus ojos
            </p>
            <div className="container-btns">
              <button onClick={onReiniciar} className="btn-other">
                Reintentar
              </button>
              <button onClick={() => navigate("/tests")} className="btn-other">
                Tests
              </button>
              
            </div>
            <Button text={"Agendar Cita"} className="agendar-cita" onClick={handleAgendarCitaClick}/>
          </div>
        </div>
      ) : (
        <div className="container-result">
          <p>
            Tu test indica que podrías tener dificultades o variaciones que
            merecen una revisión profesional. <br />
            Si realizaste la prueba con tus lentes, pueden requerir
            actualización
          </p>
          <img src={imgError} alt="imagen-ok" className="imgResult" />
          <p className="texto-importante">
            Este test NO sustituye un examen optométrico u oftalmológico
            profesional.
          </p>
          <button
            onClick={() => irASeccion("recommendations")}
            className="consejos"
          >
            Ver Consejos para Cuidar mis Ojos
          </button>
          <button
            onClick={irAClinicas}
            className="change-clinicas"
          >
            Buscar una Clínica Cerca de Mí
          </button>
          <div className="container-btns">
            <button onClick={onReiniciar} className="btn-other">
              Reintentar
            </button>
            <button onClick={() => navigate("/tests")} className="btn-other">
              Tests
            </button>
          </div>
          <Button text={"Agendar Cita"} className="agendar-cita" onClick={handleAgendarCitaClick}/>
        </div>
      )}
    </div>
  );
};

export default Resultados;
